import { TFunction } from 'i18next';

export const mapAgeCategory = (ageCategory: string | undefined, t: TFunction) => {
    return {
        ageCategoryData: {
            current: t(`loanFormat.ageCategory.${ageCategory}`, {
                defaultValue: t('yourLocalContent.yourTitles.select')
            }),
            currentKey: ageCategory ?? '',
            all: {
                Adult: t('loanFormat.ageCategory.Adult'),
                'Young Adult': t('loanFormat.ageCategory.Young Adult'),
                Children: t('loanFormat.ageCategory.Children')
            }
        }
    };
};
